class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.currentVariant = null;
    this.addEventListener('change', this.onVariantChange);
    if(document.querySelector('.option-name span[data-max-qty]')) this.setupHoverInventoryCheck();
    this.initializeCurrentVariant();
  }
  initializeCurrentVariant() {
    let variantData = this.getVariantData();
    if(variantData && variantData.length > 0){
      this.currentVariant = variantData[0];
    }
  }
  setupHoverInventoryCheck() {    
    let variants = this.querySelectorAll('.variant-wrapper label');
    variants.forEach((variant) => {
      variant.addEventListener('mouseover', (event) => {
        this.checkInventoryOnHover(event.target);
      });
      variant.addEventListener('mouseout', (event) => {
        document.querySelector('.option-name span[data-max-qty]').classList.remove('show-sold-out-qty');
      });
    });
  }
  checkInventoryOnHover(variantInput){
    let variantWrapper = variantInput.closest('.variant-wrapper');
    let variantId = variantWrapper.getAttribute('data-variant-id');
    let inventory = parseInt(variantWrapper.getAttribute('data-inventory'), 10);
    let maxQtyElement = document.querySelector('.option-name span[data-max-qty]');
    let maxQty = parseInt(maxQtyElement.getAttribute('data-max-qty'), 10);
    let variantData = this.getVariantData();
    let hoveredVariant = variantData.find(variant => variant.id == variantId);
    if(hoveredVariant && hoveredVariant.available){
      if(inventory <= maxQty){
        maxQtyElement.classList.add('show-sold-out-qty');
      }else{
        maxQtyElement.classList.remove('show-sold-out-qty');
      }
    }
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if(!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else{
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
  }
  updateURL() {
    if(__st.p.includes('product')){
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(document.querySelector('.option-name span[data-max-qty]') && checked_gender.closest('.variant-wrapper')){
        if(parseInt(checked_gender.closest('.variant-wrapper').getAttribute('data-inventory')) > parseInt(document.querySelector('.option-name span[data-max-qty]').getAttribute('data-max-qty'))){
          document.querySelector('.option-name span[data-max-qty]').classList.remove('show-sold-out-qty');
        }else{
          document.querySelector('.option-name span[data-max-qty]').classList.add('show-sold-out-qty');
        }
      }
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.remove('hide-selectore-button');
      });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.add('hide-selectore-button');
      });
      if(this.closest('.snippet-quick-buy-popup')) this.closest('.snippet-quick-buy-popup').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.remove('hide-selectore-button');
      });
      if(this.closest('.snippet-quick-buy-popup')) this.closest('.snippet-quick-buy-popup').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.add('hide-selectore-button');
      });
    }else{
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.add('hide-selectore-button');
      });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.remove('hide-selectore-button');
      });
      if(this.closest('.snippet-quick-buy-popup')) this.closest('.snippet-quick-buy-popup').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.add('hide-selectore-button');
      });
      if(this.closest('.snippet-quick-buy-popup')) this.closest('.snippet-quick-buy-popup').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.remove('hide-selectore-button');
      });
    }   
  }
  renderProductInfo(){
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    if (!productForm) return;
    productForm.forEach((form) => {
      const addButton = form.querySelector('[name="add"]');
      const addButtonText = form.querySelector('[name="add"] > span.p-add-cart-btn');
      if(this.currentVariant != undefined){
        if(this.currentVariant.available){
          form.querySelector(".choose-cart").classList.remove('variant_sold-out');
        }else{
          form.querySelector(".choose-cart").classList.add('variant_sold-out');
        }
      }
      if (!addButton) return;
      if (!modifyClass) return;
    })
  }

  setUnavailable(){
    const button = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    button.forEach((btn) => {
      const addButton = btn.querySelector('[name="add"]');
      const addButtonText = btn.querySelector('[name="add"] > span.p-add-cart-btn');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
    })
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);